<template>
  <aw-drag
    :enable="bcDocumentStore.edit"
    :drag-item="element"
    #default="{ dragHandle }"
    class="DocumentBlock -iframe"
    :class="{
      DocumentHasPlaceholder: element.placeholder,
      isCommentOpened: isCommentOpened,
      DocumentHighlightSearch: $route.hash === '#el' + element.id
    }"
    :id="'el' + element.id"
  >
    <!-- Valid URL -->
    <div class="DocumentElement -iframe">
      <div
        class="w-full bg-bc-blue flex flex-row justify-center space-x-2 p-4"
        v-if="element.locked && !isEveryElementLocked && !isPageLocked"
      >
        <aw-icon icon="lock" class="w-5 h-5 text-white " />
        <span class="text-white text-sm">{{ $t('Element is locked') }}</span>
      </div>
      <vue-resizable
        v-if="isValid"
        :minHeight="100"
        :active="activeResizing"
        :height="height"
        @resize:start="resizeStart"
        @resize:end="resizeEnd"
        :style="{ 'max-width': '100%' }"
      >
        <div
          class="IframeRef"
          :class="{ 'IframeRef--CanBeResized': canBeResized }"
        >
          <div class="Iframe">
            <div
              class="absolute inset-0 bg-white opacity-60 z-10"
              v-show="resizing || draggedElement"
            ></div>

            <iframe
              v-if="isIframe"
              :src="isValid"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              webkitallowfullscreen
            ></iframe>
            <img v-else-if="isImage" :src="isValid" @contextmenu.prevent.stop/>
          </div>

          <span
            v-show="canBeResized"
            class="absolute bottom-3 left-1/2 -mx-2.5 z-15"
          >
            <aw-icon icon="resize-down" class="w-5 h-5 text-bc-blue-raw" />
          </span>
        </div>
      </vue-resizable>

      <!-- Invalid URL -->
      <template v-if="!isValid">
        <document-embed-invalid-url-form v-if="edit" v-model="element" />
      </template>

      <!-- comments -->
      <document-comment
        v-if="bcDocumentStore.document.allow_comments"
        v-model="element.comments"
        :element="element"
        :document="bcDocumentStore.document"
        @comment-toggle="resolveZindexOnParent"
      />

      <!-- panel s moznosti noveho elementu -->
      <document-hot-action
        :parent="parent"
        :page="page"
        :index="index + 1"
        v-if="edit && !isLastOnPage"
      />
    </div>

    <!-- LEVA -->
    <div class="DocumentBlock__PanelLeft -iframe">
      <document-embed-actions v-if="edit" v-model="element" />
    </div>

    <div class="DocumentBlock__PanelRight -iframe">
      <a :href="isValid" target="_blank" class="mr-4" v-if="isValid">
        <aw-icon icon="external" class="w-5 h-5 -mx-1 "></aw-icon>
      </a>
      <span
        ref="DocumentCircle"
        class="DocumentCircle mr-2.5 sm:mr-3.5"
        :class="{
          'DocumentCircle--active': bcSelectedStore.selected.has(element.id)
        }"
        :data-item-index="element.root_rank"
        @click.prevent.stop="bcSelectedStore.select(
          element, 
          {
            isRecursive: true,
            isShift: $event.shiftKey,
            isDocument: true,
            itemIndex: element.root_rank,
          }
        )"
      ></span>
      <span
        class="cursor-move text-gray-400 hover:text-gray-500"
        v-if="edit"
        :ref="dragHandle"
      >
        <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
        <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
      </span>
    </div>
  </aw-drag>
</template>

<script>
import BaseElement from '../../mixins/BaseElement'
import Embed from '../../mixins/Embed'
import Selected from '../../mixins/Selected'
import VueResizable from 'vue-resizable/src/components/vue-resizable' // https://github.com/nikitasnv/vue-resizable

export default {
  mixins: [
    BaseElement, 
    Embed,
    Selected,
  ],
  components: { VueResizable },
  data() {
    return {
      resizing: false
    }
  },
  computed: {
    activeResizing() {
      return this.canBeResized ? ['b'] : []
    },
    canBeResized() {
      return this.isValid && this.edit
    },
    url() {
      return this.data.url
    },
    height: {
      get() {
        return this.data?.height ? this.data?.height : 'auto'
      },
      set(val) {
        this.data.height = val
        if (this.edit) {
          this.updated = 'height'
        }
      }
    }
  },
  methods: {
    resizeStart() {
      this.resizing = true
    },
    resizeEnd(event) {
      this.resizing = false
      this.height = event.height
    }
  },
  mounted() {
    this.assignItemToSelectBtn('DocumentCircle', this.element)
  },
  watch: {
    isValid: {
      handler(val) {
        if (!val) {
          this.height = null
        }
      }
    }
  }
}
</script>

<style lang="scss">
.resizable-b {
  border: 0px solid red;
  bottom: 16px !important;
}
</style>
